import { render, staticRenderFns } from "./video-item.vue?vue&type=template&id=5037259e&scoped=true"
import script from "./video-item.vue?vue&type=script&lang=js"
export * from "./video-item.vue?vue&type=script&lang=js"
import style0 from "./video-item.vue?vue&type=style&index=0&id=5037259e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037259e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCheckbox: require('/app/node_modules/vuetify/lib/components/VCheckbox/VCheckbox.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
